import SearchInput from './_search-input.js'
import Popup from './_popup.js'
import AbsolutePane from './_absolute-pane.js'
import FlexPane from './_flex-pane.js'
import Text from './_text.js'
import InfiniteList from './_infinite-list.js'

export default {
  name: 'SearchView',
  values: {
    customScrollableTarget: undefined,
    showPopover: true,
    _mobile_showPopover: false,
    minRequiredChars: 3,
    searchRequestDelay: 1,
    style: {
      searchBox: {
        position: undefined,
        width: undefined,
        _mobile_width: '100%',
        zIndex: 1,
      },
      resultsContainer: {
        maxHeight: '60vh',
        _mobile_maxHeight: '90vh',
        width: '100%',
        padding: '8px 0',
      },
    },
    searchInput: {
      configSet: SearchInput,
      configValues: {},
    },
    searchResultsPopup: {
      configSet: Popup,
      configValues: {
        container: {
          style: {
            width: '414px',
            top: '48px',
          },
        },
        arrowhead: {
          direction: 'up',
        },
        content: {
          style: {
            base: {
              padding: '0px',
            },
          },
        },
      },
    },
    resultsContentContainer: {
      configSet: AbsolutePane,
      configValues: {
        style: {
          left: '0px',
          width: '100%',
        },
      },
    },
    resultsContentContainerPopup: {
      configSet: FlexPane,
      configValues: {
        style: {
          minHeight: '108px',
        },
      },
    },
    messageContainer: {
      configSet: FlexPane,
      configValues: {
        style: {
          padding: '8px',
          _mobile_padding: '56px 8px 8px 8px',
          alignItems: 'center',
          justifyContent: 'center',
        },
      },
    },
    messageText: {
      configSet: Text,
      configValues: {
        container: {
          flexGrow: 0,
          textAlign: 'center',
        },
      },
    },
    infiniteList: {
      configSet: InfiniteList,
      configValues: {
        scrollThreshold: 0.9,
      },
    },
  },
  meta: {
    extendable: false,
  },
}
